module.exports = __webpack_public_path__ + "static/VideoEXSIS28Años-9d63d11675749b2c12cd76584e78b91d.mp4";